import { useAtomValue } from 'jotai'

import EndOfShow from '@/components/rundown/timing/EndOfShow.jsx'
import OverUnder from '@/components/rundown/timing/OverUnder.jsx'
import { rundownAtom } from '@/store/rundown.store.js'
import { ColumnHeaders } from '../column/ColumnHeaders.tsx'
import { TransportControls } from '../transport/TransportControls.tsx'
import { RundownHeaderCollapseGroupsToggle } from './RundownHeaderCollapseGroupsToggle.tsx'
import { RundownHeaderEndShow } from './RundownHeaderEndShow.tsx'
import { RundownHeaderTime } from './RundownHeaderTime.tsx'

export function RundownHeader() {
  const rundown = useAtomValue(rundownAtom)

  return (
    <div className="h-full w-fit bg-black/90 backdrop-blur-sm px-2 py-2 flex gap-1">
      <div className="flex-none w-7 flex items-end">
        <RundownHeaderCollapseGroupsToggle />
      </div>
      <div className="flex-none w-[610px] pr-2">
        <TransportControls />
      </div>
      <div className="flex flex-col justify-between">
        <div className="flex gap-6 text-sm">
          <section>
            <RundownHeaderTime />
          </section>
          <EndOfShow
            timezone={rundown?.timezone}
            todDisplayFormat={rundown?.settings?.todDisplayFormat}
          />
          <section>
            <OverUnder />
          </section>
        </div>

        <ColumnHeaders />
      </div>

      <RundownHeaderEndShow />
    </div>
  )
}
